import { jsx as t } from "react/jsx-runtime";
import { useRouter as c } from "next/router";
import { useI18n as i } from "next-localization";
import { NeuButton as s } from "@hcahealthcaredpx/neutron-react";
const p = ({ label: r, className: n, targetUrl: e }) => {
  const { t: a } = i(), o = c();
  return /* @__PURE__ */ t(s, { className: n, kind: "tertiary", icon: "arrow_back_ios", onClick: () => {
    e ? o.push(e) : o.back();
  }, children: r || a("MHO.Breadcrumb.BackLabel") });
}, B = ({ announcement: r }) => /* @__PURE__ */ t("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: r });
export {
  p as B,
  B as S
};
